import { join } from "@/utils/join"

import { NotionalInput } from "../NotionalInput"
import { useTileContext } from "../TileContext"
import {
  onRejectQuote,
  QuoteStateStage,
  RfqTimer,
  useRfqState,
} from "./RfqTimer"
import { RfqTimerProps } from "./RfqTimer/RfqTimer"

export const TileFooter = () => {
  const {
    currencyPair: { symbol },
  } = useTileContext()

  const rfq = useRfqState()

  const start =
    rfq.stage === QuoteStateStage.Received ? rfq.payload.time : undefined
  const end =
    rfq.stage === QuoteStateStage.Received
      ? rfq.payload.time + rfq.payload.timeout
      : undefined

  return (
    <TileFooterInner
      start={start}
      end={end}
      onReject={() => onRejectQuote(symbol)}
    />
  )
}

interface TileFooterInnerProps extends Omit<RfqTimerProps, "start" | "end"> {
  start?: number
  end?: number
}

export const TileFooterInner = ({
  start,
  end,
  staticProgressWidth,
  onReject,
}: TileFooterInnerProps) => (
  <div className={join("flex h-[28px] justify-center bg-primary")}>
    {start && end ? (
      <RfqTimer
        staticProgressWidth={staticProgressWidth}
        start={start}
        end={end}
        onReject={onReject}
      />
    ) : (
      <NotionalInput />
    )}
  </div>
)
